module.exports = __webpack_public_path__ + "static/media/scholarship.52abd3e1.png";